// extracted by mini-css-extract-plugin
module.exports = {"sportScheduleFeed":"SportScheduleFeed_sportScheduleFeed__2mJdy","title":"SportScheduleFeed_title__25OyB"};